export const joinName = (first, last, fallback = "") =>
  [first, last].filter(Boolean).join(" ") || fallback;

export const hasSecondaryCarer = (row) =>
  !!(row?.secondary_first_name || row?.secondary_last_name
    || row?.secondary_phone || row?.secondary_email || row?.secondary_relationship);

export const hasSecondaryCarerData = (carer) =>
  !!(carer?.first_name || carer?.last_name || carer?.mobile || carer?.email || carer?.relationship);

export const hasCarerData = hasSecondaryCarerData;

/** Family approved but has not set a portal password yet. */
export const isActivationPending = (family) => !Number(family?.password_set);

export const getApprovalStatus = (row) => {
  const status = String(row?.registration_status || row?.status || "").toLowerCase();
  if (status === "pending") return { key: "pending", label: "Pending" };
  if (status === "approved") return { key: "approved", label: "Approved" };
  if (status === "rejected") return { key: "rejected", label: "Rejected" };
  return { key: "unknown", label: "—" };
};

/** Returns null when registration is not approved yet. */
export const getAccountActivation = (row) => {
  const approval = String(row?.registration_status || row?.status || "").toLowerCase();
  if (approval !== "approved") return null;
  if (!Number(row?.password_set)) return { key: "pending", label: "Pending" };
  if (Number(row?.is_active)) return { key: "active", label: "Active" };
  return { key: "password_set", label: "Password Set" };
};

export const buildCarersFromFamily = (row) => ({
  primary: {
    first_name: row.primary_first_name || "",
    last_name: row.primary_last_name || "",
    relationship: row.primary_relationship || "",
    mobile: row.phone || "",
    email: row.email || "",
  },
  secondary: {
    first_name: row.secondary_first_name || "",
    last_name: row.secondary_last_name || "",
    relationship: row.secondary_relationship || "",
    mobile: row.secondary_phone || "",
    email: row.secondary_email || "",
  },
});
